import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "./AuthContext";
import logo from "./assets/FullnuunLogoV2.png";

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const { userLoggedIn } = useAuth();
  const scrollToSection = (event, id) => {
    if (window.location.pathname !== '/') return;
    const section = document.getElementById(id);
    if (!section) return;
    // Also handle clicking the same hash again after manually scrolling away.
    requestAnimationFrame(() => section.scrollIntoView({ block: 'start' }));
  };
  return (
    <header className="nuun-nav">
      <div className="nuun-wrap nuun-nav-inner">
        <Link to="/" aria-label="NUUN home">
          <img className="nuun-brand" src={logo} alt="NUUN" />
        </Link>
        <button
          className="nuun-menu"
          aria-expanded={open}
          aria-controls="public-navigation"
          onClick={() => setOpen(!open)}
        >
          Menu
        </button>
        <nav
          id="public-navigation"
          className={open ? "is-open" : ""}
          aria-label="Main navigation"
          onClick={() => setOpen(false)}
        >
          <NavLink to="/" end>
            Home
          </NavLink>
          <NavLink to="/browse-events">Browse Events</NavLink>
          <Link to="/#why-nuun" onClick={event => scrollToSection(event, 'why-nuun')}>Why NUUN</Link>
          <Link to="/#contact" onClick={event => scrollToSection(event, 'contact')}>Contact</Link>
          {userLoggedIn ? (
            <Link to="/events">Manage Events</Link>
          ) : (
            <Link className="nuun-login-link" to="/login">Log in</Link>
          )}
        </nav>
        <Link className="nuun-button" to="/#download-section" onClick={event => scrollToSection(event, 'download-section')}>
          Get the app
        </Link>
      </div>
    </header>
  );
}
